import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function NamePlate({
  name,
  uppercase,
}: {
  readonly name: string;
  readonly uppercase: boolean;
}) {
  return (
    <div {...stylex.props(styles.namePlate)}>
      <span {...stylex.props(styles.name, uppercase && styles.uppercase)}>
        {name}
      </span>
    </div>
  );
}

const styles = stylex.create({
  namePlate: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    backgroundColor: colors.surfaceAlt,
  },
  name: {
    paddingInline: spacing.space24,
    textAlign: "center",
    fontFamily: fonts.mono,
    fontSize: fontSizes.display,
    fontWeight: 600,
    lineHeight: 1.1,
    letterSpacing: "-0.04em",
    color: colors.foreground,
  },
  uppercase: { textTransform: "uppercase" },
});
